import http from "./http"
const account = {
  loginByAccount(dto) {
    return http.post("account/login", dto)
  },

  loginByMobile(mobile, smsCode) {
    let dto = {
      mobile: mobile,
      smsCode: smsCode,
    }
    return http.post("account/login/mobile", dto)
  },

  register(loginName, password, username, mobile, smsCode) {
    let dto = {
      loginName: loginName,
      smsCode: smsCode,
      mobile: mobile,
      username: username,
      password: password,
    }
    return http.post("account/register", dto)
  },

  resetPassword(dto) {
    return http.post("account/resetPassword", dto)
  },

  checkMobileUnique(mobile) {
    return http.get("account/checkMobileUnique?mobile=" + mobile)
  },

  checkUsernameUnique(username) {
    return http.get("account/checkUsernameUnique?username=" + username)
  },

  logout() {
    return http.get("account/logout")
  },

  sendSMSForLogin(mobile, captchaCode, captchaCodeKey) {
    return http.get("account/sms/sendForLogin?mobile=" + mobile + "&captchaCode=" + captchaCode + "&captchaCodeKey=" + captchaCodeKey)
  },

  sendSMSForRegister(mobile, captchaCode, captchaCodeKey) {
    return http.get("account/sms/sendForRegister?mobile=" + mobile + "&captchaCode=" + captchaCode + "&captchaCodeKey=" + captchaCodeKey)
  },

  sendSMSForResetPassword(mobile, captchaCode, captchaCodeKey) {
    return http.get("account/sms/sendForResetPassword?mobile=" + mobile + "&captchaCode=" + captchaCode + "&captchaCodeKey=" + captchaCodeKey)
  },
}
export default account
